import axios from "axios";

const AUTH_REFRESH_URL = `${process.env.REACT_APP_API_AUTH}/auth/refresh`;

/**
 * Hook que refresca el access token llamando al endpoint de refresh.
 * Lee token_TSE y refresh_TSE de sessionStorage, llama al endpoint y
 * actualiza token_TSE (y refresh_TSE si el servidor devuelve uno nuevo).
 *
 * @returns {{ refreshToken: () => Promise<void> }}
 */
const useRefreshToken = () => {
  const refreshToken = async () => {
    const token = sessionStorage.getItem("token_TSE");
    const refresh = sessionStorage.getItem("refresh_TSE");

    if (!token || !refresh) return;

    try {
      const response = await axios.post(
        AUTH_REFRESH_URL,
        {refresh_token: refresh},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const newAccessToken = response.data?.access_token;
      const newRefreshToken = response.data?.refresh_token;

      if (newAccessToken) {
        sessionStorage.setItem("token_TSE", newAccessToken);
      }
      if (newRefreshToken) {
        sessionStorage.setItem("refresh_TSE", newRefreshToken);
      }
    } catch (err) {
      console.warn("No se pudo refrescar el token:", err?.message);
    }
  };

  return {refreshToken};
};

export default useRefreshToken;
